import { render, staticRenderFns } from "./CTag.vue?vue&type=template&id=091000e7"
import script from "./CTag.vue?vue&type=script&lang=js"
export * from "./CTag.vue?vue&type=script&lang=js"
import style0 from "./CTag.vue?vue&type=style&index=0&id=091000e7&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('091000e7')) {
      api.createRecord('091000e7', component.options)
    } else {
      api.reload('091000e7', component.options)
    }
    module.hot.accept("./CTag.vue?vue&type=template&id=091000e7", function () {
      api.rerender('091000e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CTag.vue"
export default component.exports